import React from "react";
import { Camera } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCamara } from "@/components/Camara";

// Bienvenida del primer inicio: una sola acción (foto) o entrar en Inicio.
export const BienvenidaInicial = ({ onFin }) => {
  const { user } = useAuth();
  const nombre = (user?.nombre || "").trim().split(/\s+/)[0];
  const elegir = (e) => { const f = e.target.files && e.target.files[0]; e.target.value = ""; if (f) onFin("foto", f); };
  const camara = useCamara(elegir);
  return (
    <div className="fixed inset-0 z-[90] bg-[#FAF8F5] flex flex-col" data-testid="bienvenida-inicial" role="dialog" aria-modal="true" aria-label="Bienvenida"
      style={{ paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="flex-1 flex flex-col items-center justify-center px-7 text-center max-w-md mx-auto w-full">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#1C2421] tracking-tight leading-tight" data-testid="bienvenida-inicial-saludo">
          {nombre ? `Hola, ${nombre}.` : "Hola."}<br /><span className="text-[#3A6B56]">Vamos a poner AL DÍA en marcha.</span>
        </h1>
        <span className="mt-10 w-28 h-28 rounded-full bg-[#E8F0EC] flex items-center justify-center"><Camera size={52} className="text-[#3A6B56]" strokeWidth={1.7} /></span>
        <p className="text-xl text-[#4A5550] mt-6 leading-relaxed">Haz una foto de un documento o ticket para ver cómo funciona.</p>
      </div>
      <div className="px-5 pb-8 max-w-md mx-auto w-full space-y-3">
        {camara.inputs}
        <button type="button" onClick={camara.abrir} data-testid="bienvenida-inicial-foto" className="w-full min-h-[60px] rounded-2xl bg-[#3A6B56] text-white font-bold text-xl hover:bg-[#2E5645] flex items-center justify-center gap-2">
          <Camera size={24} /> Hacer una foto
        </button>
        {camara.esMovil && <button type="button" onClick={camara.elegirGaleria} data-testid="bienvenida-inicial-galeria" className="w-full min-h-[48px] text-[#3A6B56] font-semibold text-base underline underline-offset-4">o elegir de la galería</button>}
        {camara.aviso}
        <button data-testid="bienvenida-inicial-ahora-no" onClick={() => onFin("saltada")} className="w-full min-h-[56px] rounded-2xl bg-white border-2 border-[#E5DFD5] text-[#1C2421] font-semibold text-lg">Ahora no</button>
      </div>
    </div>
  );
};
